<template>
      <h1 :class="color"><slot></slot></h1>
</template>

<script>
export default {
  props: ['color'],
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

h1 {
  font-family: $font-semi-condensed;
  font-weight: 900;
  font-style: normal;
  color:black;
  text-decoration: none;
  font-size:4.5em;
  margin-top:20px;
  text-align: center;
  line-height:1.1em;
  @include for-size(phone-only) {
    font-size:2em;
  }
  @include for-size(tablet-portrait-up) {
    font-size:3.8em;
  }
  &.white {
    color:white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/H1Title.vue